import { Nullable } from '@clearverify/types';

import { ActiveInactive } from 'src/api';

import {
  PrivacySettingsRequirementOptions,
  VerificationPreferenceFormFields,
  VerificationPreferenceFormValues,
} from '../types';

const getVerificationPrivacySettingsRequirement = (
  requestAutoApprove: Nullable<ActiveInactive>,
): PrivacySettingsRequirementOptions => {
  if (requestAutoApprove === ActiveInactive.Active) {
    return PrivacySettingsRequirementOptions.allowAll;
  }

  if (requestAutoApprove === ActiveInactive.Inactive) {
    return PrivacySettingsRequirementOptions.requireWithMyApprove;
  }
  return PrivacySettingsRequirementOptions.requireWithMyApprove;
};

export const getVerificationPreferenceInitialValues = (
  requestAutoApprove: Nullable<ActiveInactive>,
): VerificationPreferenceFormValues => {
  return {
    [VerificationPreferenceFormFields.verificationPreference]:
      getVerificationPrivacySettingsRequirement(requestAutoApprove),
  };
};
